import React, { useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';
import { get } from 'lodash';

import { CardComponent, PageHeader, ImageUploader } from 'components';
import { ACCEPT_EXTENSIONS } from 'components/ImageUploader/constants';
import { useServerErrorActions } from 'contexts/ServerErrorContext';
import { DOWNLOAD_SECTIONS } from 'contexts/UploadStatusContext/constants';
import { useBusyProgressActions } from 'contexts/BusyProgressContext';
import { otherAssetsModel } from 'models';
import { ROUTES } from 'routes/constants';
import { getTWithPathKey } from 'utils';
import { withPagination, withPaginationPropTypes } from 'utils/enhancers';
import { useDeleteSelectedAssets } from 'hooks';

function OtherAssetsImages({ paginationItemsCount, paginationParams, setPaginationItemsCount, resetPaginationPage }) {
  const [images, setImages] = useState([]);
  const { handleServerError } = useServerErrorActions();
  const { withPageProgressHandler } = useBusyProgressActions();
  const { handleDeleteAllRequest } = useDeleteSelectedAssets()
  const getT = getTWithPathKey('pages.assets.OtherAssetsImages');

  useEffect(() => {
    getImages();
  }, [paginationParams]);

  const getImages = withPageProgressHandler(() =>
    otherAssetsModel
      .getImages(paginationParams)
      .then(({ otherAssets, otherAssetsCount }) => {
        setImages(otherAssets);
        setPaginationItemsCount(otherAssetsCount);
      })
      .catch(handleServerError)
  );

  const loadImage = image => {
    const signedId = get(image, 'signed_id');

    return otherAssetsModel.postImage({ signedId }).then(resetPaginationPage);
  };

  const unloadImage = imageId => {
    otherAssetsModel.deleteImage(imageId).then(getImages).catch(handleServerError);
  };

  const handleEditImage = (id, data) => otherAssetsModel.editImage(id, data).then(getImages).catch(handleServerError);

  return (
    <>
      <PageHeader title={`UI Image Assets: ${paginationItemsCount}`} backLink={ROUTES.assets} />
      <Grid container spacing={6}>
        <CardComponent sm={12} title={getT('title')}>
          <ImageUploader
            images={images}
            loadImage={loadImage}
            unloadImage={unloadImage}
            handleDeleteAll={assets => handleDeleteAllRequest(assets, otherAssetsModel.deleteImage, getImages)}
            handleServerError={handleServerError}
            text={getT('imageUploaderText')}
            accept={ACCEPT_EXTENSIONS.imgIcon}
            section={DOWNLOAD_SECTIONS.otherAssets}
            withEdit
            handleEdit={handleEditImage}
            withUploadButton
          />
        </CardComponent>
      </Grid>
    </>
  );
}

OtherAssetsImages.propTypes = {
  ...withPaginationPropTypes,
};

export default withPagination(OtherAssetsImages);
